// extracted by mini-css-extract-plugin
export default {"footerSection":"Footer_footerSection__q6hVJ","footer":"Footer_footer__kXlYa","wraperMedia":"Footer_wraperMedia__EDSbc","wraperMediaTablet":"Footer_wraperMediaTablet__94EfL"};